export default __webpack_public_path__ + "static/media/interiors1.5e350b0a.jpeg";